(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#main-nav');
  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(open));
    nav?.classList.toggle('open', open);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && nav?.classList.contains('open')) {
      nav.classList.remove('open');
      menu?.setAttribute('aria-expanded', 'false');
      menu?.focus();
    }
  });
  document.querySelectorAll('[data-carousel]').forEach(group => {
    const rail = group.querySelector('[data-carousel-rail]');
    const prev = group.querySelector('[data-carousel-prev]');
    const next = group.querySelector('[data-carousel-next]');
    const status = group.querySelector('[data-carousel-status]');
    if (!rail || !prev || !next) return;
    const stride = () => (rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth) + (parseFloat(getComputedStyle(rail).gap) || 0);
    const visible = () => Math.max(1, Math.round((rail.clientWidth + (parseFloat(getComputedStyle(rail).gap) || 0)) / stride()));
    const sync = () => {
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      const index = Math.max(0, Math.round(rail.scrollLeft / stride()));
      if (status) {
        status.textContent = group.dataset.carousel === 'experts'
          ? (Math.floor(index / visible()) + 1) + ' / ' + Math.ceil(rail.children.length / visible())
          : (index + 1) + '–' + Math.min(index + visible(), rail.children.length) + ' / ' + rail.children.length;
      }
    };
    const move = direction => rail.scrollBy({left: direction * stride() * (group.dataset.carousel === 'experts' ? visible() : 1), behavior: reduced ? 'instant' : 'smooth'});
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', sync, {passive:true});
    rail.addEventListener('keydown', e => {
      if (e.target === rail && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        e.preventDefault(); move(e.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    window.addEventListener('resize', sync);
    rail.querySelectorAll('img').forEach(image => image.addEventListener('load', sync, {once:true}));
    sync();
  });
  const setSize = input => {
    const setImage = (image, boxed) => {
      const srcset = boxed ? input.dataset.boxImageSrcset : input.dataset.imageSrcset;
      image.srcset = srcset || '';
      image.src = (boxed ? input.dataset.boxImage : input.dataset.image);
    };
    const output = document.querySelector('[data-price-output]');
    const photo = document.querySelector('.purchase-image');
    const buy = document.querySelector('.buy-link');
    if (output) output.textContent = input.dataset.price;
    document.querySelectorAll('[data-sticky-price]').forEach(e => e.textContent = input.dataset.price);
    document.querySelectorAll('[data-sticky-size]').forEach(e => e.textContent = input.dataset.size || input.value);
    if (photo) {
      const boxed = document.querySelector('[data-product-view][aria-pressed="true"]')?.dataset.productView === 'box';
      setImage(photo, boxed);
      photo.alt = (document.querySelector('.product-intro h1')?.textContent || 'Balm') + ' ' + (input.dataset.size || input.value) + ' mL balm jar' + (boxed ? ' on its box' : '');
    }
    document.querySelectorAll('[data-product-view]').forEach(button => {
      const thumbnail = button.querySelector('img');
      if (thumbnail) setImage(thumbnail, button.dataset.productView === 'box');
    });
    if (buy && buy.dataset.store) {
      const url = new URL(buy.dataset.store);
      if (input.dataset.variant) url.searchParams.set('variant', input.dataset.variant);
      buy.href = url.href;
    }
  };
  const setProductView = view => {
    document.querySelectorAll('[data-product-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.productView === view)));
    const selected = document.querySelector('.sizes input:checked');
    if (selected) setSize(selected);
  };
  document.querySelectorAll('.sizes input').forEach(input => input.addEventListener('change', () => setSize(input)));
  document.querySelectorAll('[data-product-view]').forEach(button => button.addEventListener('click', () => setProductView(button.dataset.productView)));
  const search = document.querySelector('[data-science-search]');
  search?.addEventListener('input', () => {
    const query = search.value.trim().toLowerCase();
    let count = 0;
    document.querySelectorAll('[data-science-tile]').forEach(tile => {
      tile.hidden = !tile.dataset.search.toLowerCase().includes(query);
      if (!tile.hidden) count++;
    });
    const status = document.querySelector('[data-search-status]');
    if (status) status.textContent = query ? count + ' ingredient stories found' : '';
  });
  const scienceSlugs = ['liposomal-botanicals','mangosteen','three-forms-magnesium','clove','peppermint','bergamot-bergamot-mint','pomegranate','green-tea-grape','antioxidant-superfruits','ginger-turmeric','vitamins-c-e','the-base'];
  const sciencePaths = new Set(scienceSlugs.map(s => '/pages/ingredient-' + s + '/'));
  const isDetailUrl = url => { const v = url.searchParams.get('view') || ''; return sciencePaths.has(url.pathname) || v.startsWith('science-') || v === 'how-to-use'; };
  const originLabel = a => {
    if (a && a.closest('.evidence-map, [data-compact-evidence]')) return 'Back to Evidence Map';
    if (document.querySelector('.science-hub-heading')) return 'Back to Ingredients & Science';
    const pdp = document.querySelector('.product-hero[data-purchase-product]')?.dataset.purchaseProduct;
    if (pdp === 'ultimate') return 'Back to ULTIMATE';
    if (pdp === 'muscle-aid') return 'Back to MUSCLE-AID';
    return 'Back';
  };
  const isScience = document.body.hasAttribute('data-science-page');
  const isUse = location.pathname.replace(/\/$/, '') === '/pages/how-to-use' || location.pathname === '/review/how-to-use/';
  const isDetailPage = isScience || isUse;
  sciencePaths.add('/pages/how-to-use/');
  sciencePaths.add('/review/how-to-use/');
  [...sciencePaths].forEach(p => sciencePaths.add(p.replace(/\/$/, '')));
  const storage = {
    get(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } },
    set(key,value) { try { sessionStorage.setItem(key,JSON.stringify(value)); } catch {} },
    remove(key) { try { sessionStorage.removeItem(key); } catch {} }
  };
  function capture(a) {
    return {
      label: originLabel(a),
      path: location.pathname + location.search,
      hash: location.hash,
      scrollY: window.scrollY,
      details: [...document.querySelectorAll('details[id][open]')].map(d => d.id),
      rails: [...document.querySelectorAll('[data-carousel-rail]')].map(r => ({id:r.id,left:r.scrollLeft})),
      size: document.querySelector('.sizes input:checked')?.value,
      productView: document.querySelector('[data-product-view][aria-pressed="true"]')?.dataset.productView,
      time: Date.now()
    };
  }
  function validOrigin(origin) {
    return origin && typeof origin.path === 'string' && origin.path.startsWith('/') && !origin.path.startsWith('//') &&
      !sciencePaths.has(origin.path.split('?')[0]) && Number.isFinite(origin.time) && Date.now() - origin.time < 7200000 &&
      Number.isFinite(origin.scrollY) && Array.isArray(origin.details) && Array.isArray(origin.rails);
  }
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]');
    if (!a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
    const url = new URL(a.href,location.href);
    if (!isDetailPage && url.origin === location.origin && isDetailUrl(url)) storage.set('cbScienceOrigin',capture(a));
    if (isDetailPage && (a.hasAttribute('data-science-return') || a.hasAttribute('data-use-return'))) {
      const origin = storage.get('cbScienceOrigin');
      if (validOrigin(origin)) storage.set('cbResume',origin.path);
    }
  });
  if (isDetailPage) {
    const origin = storage.get('cbScienceOrigin');
    document.querySelectorAll(isUse ? '[data-use-return]' : '[data-science-return]').forEach(a => {
      if (validOrigin(origin)) {
        a.href = origin.path + (origin.hash || '');
        const arrow = /^\s*\u2190/.test(a.textContent) ? '\u2190 ' : '';
        a.textContent = arrow + (typeof origin.label === 'string' && /^Back( to [A-Za-z&\- ]+)?$/.test(origin.label) ? origin.label : 'Back');
      }
    });
  }
  async function settleLayout() {
    if (document.fonts?.ready) await document.fonts.ready;
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  }
  async function restore() {
    if (isDetailPage) return;
    const origin = storage.get('cbScienceOrigin');
    const path = location.pathname + location.search;
    const type = performance.getEntriesByType('navigation')[0]?.type;
    if (validOrigin(origin) && origin.path === path && (storage.get('cbResume') === path || type === 'back_forward')) {
      history.scrollRestoration = 'manual';
      document.querySelectorAll('details[id]').forEach(d => { d.open = origin.details.includes(d.id); });
      if (origin.size) {
        const input = document.querySelector('.sizes input[value="' + origin.size + '"]');
        if (input) { input.checked = true; setSize(input); }
      }
      if (origin.productView) setProductView(origin.productView);
      await settleLayout();
      origin.rails.forEach(saved => {
        const element = document.getElementById(saved.id);
        if (element) element.scrollLeft = saved.left;
      });
      window.scrollTo({top:origin.scrollY,behavior:'instant'});
      storage.remove('cbResume');
      return;
    }
    if (/^#(ultimate|muscle-aid)-/.test(location.hash)) {
      const card = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (card) {
        const details = card.querySelector('details');
        if (details) details.open = true;
        await settleLayout();
        card.scrollIntoView({block:'start',inline:'center',behavior:'instant'});
      }
    }
  }
  window.addEventListener('pageshow',restore);
})();
